import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { VisorWrapperComponent } from './visor-wrapper/visor-wrapper.component'; 

const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: 'visor-wrapper/', // <-- ¡Aquí agregamos el parámetro :id!
        component: VisorWrapperComponent,
        data: {
          title: "Visor",
          breadcrumb: "Visor"
        }
      },
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class VisorRoutingModule { }
